/** A feed request must settle: SWR keeps the last good page on rejection. */
export const ACTIVITY_REQUEST_TIMEOUT_MS = 10_000

export async function activityFetcher(url: string): Promise<any[]> {
	const controller = new AbortController()
	const timer = setTimeout(() => controller.abort(), ACTIVITY_REQUEST_TIMEOUT_MS)
	try {
		const response = await fetch(url, { cache: 'no-store', signal: controller.signal })
		if (!response.ok) throw new Error(`Activity request failed (${response.status})`)
		const data = await response.json()
		if (!Array.isArray(data) || data.some(row => !row || typeof row !== 'object')) {
			throw new Error('Invalid activity response')
		}
		return data
	} finally {
		clearTimeout(timer)
	}
}
